module.exports = __webpack_public_path__ + "img/sh.8bb55680.png";